import React from 'react'
import './editionCompStyles.css'
import logoToss from '../assets/logo_toss_noir.png'

const EditionComp =({image,title,nb_sports,nb_part,nb_ecoles,color,index,annulee,textAnnululation})=>{
  return (
    <div className='edition-component'>
        <h2> {title}</h2>
      
        <div className='edition-line'>
            <div className='line'></div>
            <img  src={logoToss} alt="" />
            <div className='line'></div>
        </div>
        {index %2 === 0 ?
        <div className='edition-component-content'>
        <div className='edition-row'> 
        { annulee === 0 ? <>
            <div className='edition-column'>
                <div className='edition-circle'>
                <h3> {nb_sports}</h3>
                </div>
                <h4 style={{color:color}}> Sports</h4>
            </div>
            <div className='edition-column'>
                <div className='edition-circle'>
                <h3> {nb_ecoles}</h3>
                </div>
                <h4 style={{color:color}}> écoles participantes</h4>
            </div>
            <div className='edition-column'>
                <div className='edition-circle'>
                <h3> {nb_part}</h3>
                </div>
                <h4 style={{color:color}}> Participants</h4>
            </div></>:<>
            <div className='edition-column'>
                <h1> {textAnnululation}</h1>
            </div></>
        
        }
           
        </div>
        
   
        <div className='edition-image'>
             <img  src={image} alt="" />

        </div>
    </div>:
    <div className='edition-component-content'>
          <div className='edition-image'>
         <img  src={image} alt="" />

    </div>
    <div className='edition-row'> 
    { annulee === 0 ? <>
            <div className='edition-column'>
                <div className='edition-circle'>
                <h3> {nb_sports}</h3>
                </div>
                <h4 style={{color:color}}> Sports</h4>
            </div>
            <div className='edition-column'>
                <div className='edition-circle'>
                <h3> {nb_ecoles}</h3>
                </div>
                <h4 style={{color:color}}> écoles participantes</h4>
            </div>
            <div className='edition-column'>
                <div className='edition-circle'>
                <h3> {nb_part}</h3>
                </div>
                <h4 style={{color:color}}> Participants</h4>
            </div></>:<>
            <div className='edition-column'>
                <h1> {textAnnululation}</h1>
            </div></>
        
        }
    </div>
    

  
</div>
    }
        

      
    </div>
  )
}

export default EditionComp
